module.exports = __webpack_public_path__ + "media/images/growth_mindset/title-page-bg-ef2a50bb45551cd8676f9bc57d776bd9.png";